import { render, staticRenderFns } from "./ChangeCourseModal.vue?vue&type=template&id=dd79a5e8"
import script from "./ChangeCourseModal.vue?vue&type=script&lang=js"
export * from "./ChangeCourseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports